export enum CodeMessageLabel {
  NO_CERVED_DATA = "Il sistema non ha trovato il codice fiscale inserito nelle banche dei dati camerali a cui Check si appoggia. Per attivare l'account si prega di contattare il supporto al numero verde 800 036 458",
  CANNOT_CREATE_USER = "Impossibile creare l'utente: PEC invalida o già in uso da un altro utente",
  NO_PEC = "Non è stata trovata nessuna PEC. Per attivare l'account si prega di contattare il supporto al numero verde 800 036 458"
}
